module.exports = __webpack_public_path__ + "static/media/CTLA_10-135w.a89ac3a8.webp";